<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img">
      <!-- <video
        class="background_video"
        autoplay
        muted
        loop
        playsinline
      >
        <source src="@/assets/img/hly/new/工具云/工具云视频.mp4" type="video/mp4" />
      </video> -->
      <!-- <div class="img_tit hidden-xs-only">{{ $t('toolCloudPage.title') }}</div>
      <div class="img_tit hidden-sm-and-up">{{ $t('toolCloudPage.title') }}</div> -->
    </div>
    <div class="production_title_wrap">
      <div class="tools_grid">
        <div
          class="tool_card"
          v-for="(item, index) in tools"
          :key="index"
          @click="handleExternalLink(item)"
        >
          <div class="laptop_container">
            <div class="laptop_graphic">
              <div class="laptop_screen">
                <img :src="item.screenImage" :alt="item.nameKey" class="screen_content" />
              </div>
            </div>
          </div>
          <div class="tool_info">
            <div class="info_header">
              <div class="small_icon">
                <img :src="item.screenImage" :alt="item.nameKey" class="icon_content" />
              </div>
              <div class="divider"></div>
              <h3 class="tool_title">{{ $t(item.nameKey) }}</h3>
            </div>
            <!-- <p class="cooperation_date">{{ $t('toolCloudPage.time') }}: {{ item.cooperationDate }}</p> -->
            <p class="tool_description">{{ $t(item.descriptionKey) }}</p>
            <button class="view_content_btn">{{ $t('toolCloudPage.viewContent') }}</button>
          </div>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

// 导入工具相关的图片
import cbamImg from '@/assets/img/hly/new2/com-cbam.png'
import redcImg from '@/assets/img/hly/new2/com-redc.png'
import gylImg from '@/assets/img/hly/new2/com-gyl.png'
import esgImg from '@/assets/img/hly/new2/com-esg.png'

export default {
  data() {
    return {
      tools: [
        {
          nameKey: 'toolCloudPage.tools.cbam.title',
          descriptionKey: 'toolCloudPage.tools.cbam.description',
          cooperationDate: '2025/06/26',
          screenImage: cbamImg,
          click(vm) {
            vm.$router.push('/cbam').catch(() => {});
          }
        },
        {
          nameKey: 'toolCloudPage.tools.carbonPlatform.title',
          descriptionKey: 'toolCloudPage.tools.carbonPlatform.description',
          cooperationDate: '2025/06/26',
          screenImage: redcImg,
          url: 'https://redc.carbon-tc.com/',
        },
        {
          nameKey: 'toolCloudPage.tools.supplyChainAudit.title',
          descriptionKey: 'toolCloudPage.tools.supplyChainAudit.description',
          cooperationDate: '2025/06/26',
          screenImage: gylImg,
          click(vm) {
            vm.$router.push('/SupplyChainAudit').catch(() => {});
          }
        },
        {
          nameKey: 'toolCloudPage.tools.esgEvaluation.title',
          descriptionKey: 'toolCloudPage.tools.esgEvaluation.description',
          cooperationDate: '2025/06/26',
          screenImage: esgImg,
          click(vm) {
            vm.$router.push('/ESG-evaluation').catch(() => {});
          }
        },
      ],
    }
  },
  methods: {
    handleExternalLink(item) {
      if (item.click && typeof item.click === 'function') {
        item.click(this); // 传入 Vue 实例，用于 this.$router
      } else if (item.url) {
        window.open(item.url, '_blank'); // 外部链接跳转
      }
    },
  },
  components: {
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;

  .enter_img {
    width: 100%;
    height: 300px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-image: url('../../assets/img/hly/new2/菜单栏封面图.png');
    background-repeat: no-repeat;
    background-position: center top;
    /* 决定图片是完整显示还是铺满 */
    background-size: contain;

    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .learn-more {
      background: #f29c11;
      font-size: 20px;
      color: #fff;
      border: none;
      padding: 0.5rem 1.5rem;
      border-radius: 5px;
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 150%);
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
        margin-top: -1.5rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .production_title_wrap {
    .tools_grid {
      width: 80%;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      padding: 40px 0;

      .tool_card {
        width: 100%;
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        display: flex;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
        }

        .laptop_container {
          width: 40%;
          padding: 30px;
          display: flex;
          align-items: center;
          justify-content: center;

          .laptop_graphic {
            width: 100%;
            max-width: 300px;
            position: relative;

            .laptop_screen {
              width: 100%;
              aspect-ratio: 16 / 10;
              border-radius: 10px;
              position: relative;

              &::before {
                content: '';
                position: absolute;
                top: -5px;
                left: -5px;
                right: -5px;
                bottom: -5px;
                background: #f5f5f5;
                border-radius: 15px;
                z-index: -1;
              }

              .screen_content {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 10px;
              }
            }
          }
        }

        .tool_info {
          width: 60%;
          padding: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .info_header {
            display: flex;
            align-items: center;
            margin-bottom: 15px;

            .small_icon {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 15px;
              flex-shrink: 0;

              .icon_content {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .divider {
              width: 1px;
              height: 25px;
              background-color: #409EFF;
              margin: 0 15px;
            }

            .tool_title {
              font-size: 24px;
              font-weight: bold;
              color: #333;
              margin: 0;
            }
          }

          .cooperation_date {
            font-size: 14px;
            color: #666;
            margin-bottom: 15px;
          }

          .tool_description {
            font-size: 16px;
            color: #555;
            margin-bottom: 25px;
            line-height: 1.6;
          }

          .view_content_btn {
            background-color: #409EFF;
            color: #fff;
            padding: 12px 24px;
            border-radius: 6px;
            border: none;
            cursor: pointer;
            font-size: 16px;
            font-weight: bold;
            transition: background-color 0.3s ease;
            align-self: flex-start;

            &:hover {
              background-color: #66b1ff;
            }
          }
        }
      }

      @media screen and (max-width: 768px) {
        width: 90%;
        grid-template-columns: 1fr;
        gap: 20px;

        .tool_card {
          flex-direction: column;

          .laptop_container {
            width: 100%;
            padding: 20px;

            .laptop_graphic {
              max-width: 250px;
            }
          }

          .tool_info {
            width: 100%;
            padding: 20px;

            .info_header {
              .tool_title {
                font-size: 20px;
              }
            }

            .tool_description {
              font-size: 14px;
            }

            .view_content_btn {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
